exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat+Alternates);", ""]);

// module
exports.push([module.id, ".search-container[data-v-3fcadc58]{display:flex;flex-direction:column;width:100%;height:100%;margin-top:30vh}.search-container h2[data-v-3fcadc58]{font-family:Montserrat Alternates,sans-serif;font-size:36pt;font-weight:900;font-style:normal;color:#4a148c;width:100%;padding:0 0 5px;margin:0}.search-input[data-v-3fcadc58]{margin:0 auto}.menu[data-v-3fcadc58]{top:25px;right:50px;position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fcadc58","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Views/MainSearch.vue
// module id = 28
// module chunks = 0